import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2752bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "output" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("生产状态看板")
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Assembly Status Kanban")
const _hoisted_7 = { class: "output_top clearfix" }
const _hoisted_8 = { class: "left clearfix" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "output_top_item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "计划产量"),
  /*#__PURE__*/_createElementVNode("p", null, "Output")
], -1))
const _hoisted_10 = {
  class: "output_top_item_value",
  style: {"transform":"translateX(25px)"}
}
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "right" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "output_top_item",
  style: {"margin-right":"60px"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "实际产量"),
  /*#__PURE__*/_createElementVNode("p", null, "Complete")
], -1))
const _hoisted_14 = { class: "output_top_item_value" }
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "left clearfix bottom" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "output_top_item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "节拍时间"),
  /*#__PURE__*/_createElementVNode("p", null, "Takt time")
], -1))
const _hoisted_18 = {
  class: "output_top_item_value",
  style: {"margin-left":"27px"}
}
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "right bottom" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "output_top_item",
  style: {"transform":"translateX(-20px)","margin-left":"38px"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, "剩余时间"),
  /*#__PURE__*/_createElementVNode("p", null, "Remain")
], -1))
const _hoisted_22 = {
  key: 0,
  class: "output_top_item_value",
  style: {"color":"#1aff00"}
}
const _hoisted_23 = ["textContent"]
const _hoisted_24 = {
  key: 1,
  class: "output_top_item_value",
  style: {"color":"#f7ff00"}
}
const _hoisted_25 = ["textContent"]

import { reactive, onMounted, nextTick } from 'vue'
import axios from '@/utils/http'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  productionLineName: '',
  remaindTime: '--:--',
  beatTime: '--:--',
  endNumber: 0,
  planNumber: 60,
  englishProductionLineName: '',
  timeRemainMinutes: 0,
  lineCode: '',
  lineStoped: false,
  showType: '黑色简易'
})

onMounted(() => {
  getParam()
  getSimpleLineInfo()
  setInterval(getSimpleLineInfo, 5000)
})
const getParam = () => {
  const url = window.location.href
  const dzUrl = url.split('#')[0]
  const cs = dzUrl.split('?')[1]
  data.lineCode = cs.split('=')[1]
}
const getSimpleLineInfo = () => {
  if (data.lineCode.length === 0) {
    return
  }
  axios.get('/api/board/getLineInfo/' + data.lineCode).then(res => {
    if (res.code === 200) {
      if (res.data.showType !== data.showType) {
        window.location.reload()
      }
      data.remaindTime = res.data.timeRemain
      data.beatTime = res.data.beat
      data.endNumber = res.data.completeNumber
      data.planNumber = res.data.planNumber
      data.productionLineName = res.data.productionLineName
      data.englishProductionLineName = res.data.englishProductionLineName
      data.timeRemainMinutes = res.data.timeRemainMinutes
      data.lineStoped = res.data.lineStoped
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_unref(data).productionLineName)
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_unref(data).englishProductionLineName)
        }, null, 8, _hoisted_5),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", {
            textContent: _toDisplayString(_unref(data).planNumber)
          }, null, 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            textContent: _toDisplayString(_unref(data).endNumber)
          }, null, 8, _hoisted_15)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", {
            textContent: _toDisplayString(_unref(data).beatTime)
          }, null, 8, _hoisted_19)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        (_unref(data).lineStoped)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_unref(data).remaindTime)
              }, null, 8, _hoisted_23)
            ]))
          : _createCommentVNode("", true),
        (!_unref(data).lineStoped)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("span", {
                textContent: _toDisplayString(_unref(data).remaindTime)
              }, null, 8, _hoisted_25)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})